'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useExplicitFreeTurnBranding } from '#pplx/frontend/apps/ask/hooks/computer-access-hooks/useAsiAccessDecision.js';
import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
/**
 * Free-turn preview label for the unified homepage Computer chin. Renders as a trailing
 * chin row item, so it appears and collapses with the chin.
 */
export const HomeFreePreviewLabel = React.memo(function HomeFreePreviewLabel() {
    const isComputer = useSelectedSearchMode() === SearchMode.ASI;
    // Only evaluate the experiment in Computer mode, matching its exposure population.
    const showExplicitFreeTurnBranding = useExplicitFreeTurnBranding({
        enabled: isComputer,
    });
    // Keep the last Computer-mode value while the chin collapses on a switch to Search.
    const [heldVisible, setHeldVisible] = useState(false);
    if (isComputer && showExplicitFreeTurnBranding !== heldVisible) {
        setHeldVisible(showExplicitFreeTurnBranding);
    }
    const visible = isComputer ? showExplicitFreeTurnBranding : heldVisible;
    if (!visible)
        return null;
    return (_jsx("span", { className: "shrink-0 select-none whitespace-nowrap text-3xs uppercase leading-none tracking-wider text-super-primary", "data-testid": "home-free-preview-label", children: _jsx("span", { className: "opacity-65 dark:opacity-50", children: _jsx(FormattedMessage, { defaultMessage: "Free preview", description: "Label in the Computer homepage input footer for free preview access", id: "96c79428dd" }) }) }));
});
//# sourceMappingURL=HomeFreePreviewLabel.js.map